angular
    .module('app.entity.menu.plugin-visit-completion', ['app.entity.service'])
    .factory('EntityMenuPluginVisitCompletion', [
        'CrfService',
        'FieldsCompletionService',
        'FieldCompletionStatusService',
        'CrdConfigurationService',
        'FormFieldsService',
        'RecordDataService',
        function(
            CrfService,
            FieldsCompletionService,
            FieldCompletionStatusService,
            CrdConfigurationService,
            FormFieldsService,
            RecordDataService
        ) {
            function hasChanged(previousValue, newValue) {
                previousValue = previousValue || {};
                newValue = newValue || {};

                return ['completed', 'overdue', 'planned', 'pending', 'total'].some(
                    function(key) {
                        return previousValue[key] !== newValue[key];
                    }
                );
            }

            function isFieldRequired(field, listIndices) {
                // Same logic as Completion.js isFieldRequired method
                if (!field.isRequired()) {
                    return false;
                }

                var fieldId = field.getId();

                // Check if field is available (visible and editable)
                return FormFieldsService.isFieldAvailable(fieldId, listIndices);
            }

            function calculateVisitCompletion(element, listIndices) {
                var visitCompletion = {
                    completed: 0,
                    overdue: 0,
                    planned: 0,
                    pending: 0,
                    total: 0,
                    visitBased: true,
                };

                if (!CrdConfigurationService.hasScheduledVisits()) {
                    // Fallback to standard completion
                    var completion = FieldsCompletionService.getCompletion(
                        element,
                        listIndices
                    );

                    return {
                        completed: completion.completed || 0,
                        overdue: 0,
                        planned: 0,
                        pending: completion.pending || 0,
                        total: completion.required || 0,
                        visitBased: false,
                    };
                }

                // Handle lists differently - same as Completion.js getListCompletion
                if (element.isList()) {
                    return calculateListVisitCompletion(element, listIndices);
                }

                // Handle sections - same as Completion.js getSectionCompletion
                if (element.isSection()) {
                    return calculateSectionsContainerVisitCompletion(
                        element,
                        listIndices
                    );
                }

                // Filter required fields upfront, same as Completion.js
                var allRequiredFields = element.getRequiredFields
                    ? element.getRequiredFields()
                    : [];

                var requiredFields = allRequiredFields.filter(function(field) {
                    return isFieldRequired(field, listIndices);
                });

                visitCompletion.total = requiredFields.length;

                requiredFields.forEach(function(field) {
                    var fieldCompletion = FieldsCompletionService.getFieldCompletion(
                        field,
                        listIndices
                    );

                    if (fieldCompletion) {
                        visitCompletion.completed++;
                    }
                    else {
                        // Field is empty - classify by visit status
                        var fieldId = field.getId ? field.getId() : field.id;
                        var visitState = FieldCompletionStatusService.getFieldCompletionStatus(
                            fieldId
                        );
                        switch (visitState) {
                            case 'overdue':
                                visitCompletion.overdue++;
                                break;
                            case 'planned':
                                visitCompletion.planned++;
                                break;
                            default:
                                visitCompletion.pending++;
                                break;
                        }
                    }
                });

                return visitCompletion;
            }

            function calculateListVisitCompletion(listElement, listIndices) {
                var visitCompletion = {
                    completed: 0,
                    overdue: 0,
                    planned: 0,
                    pending: 0,
                    total: 0,
                    visitBased: true,
                };

                if (!CrdConfigurationService.hasScheduledVisits()) {
                    // Fallback to standard completion for lists
                    var completion = FieldsCompletionService.getListCompletion(
                        listElement,
                        listIndices
                    );

                    return {
                        completed: completion.completed || 0,
                        overdue: 0,
                        planned: 0,
                        pending: completion.pending || 0,
                        total: completion.required || 0,
                        visitBased: false,
                    };
                }

                // Same logic as Completion.js getListCompletion - only process existing items
                var listId = listElement.getId();
                var listData = RecordDataService.getList(listId, listIndices) || [];

                // If no items in list, return empty completion
                if (listData.length === 0) {
                    return visitCompletion;
                }

                // Sum completion of all existing list items
                listData.forEach(function(itemData, index) {
                    var itemIndices = angular.copy(listIndices);
                    itemIndices[listId] = index + 1; // listIndices starts at 1

                    var itemCompletion = calculateListItemVisitCompletion(
                        listElement,
                        itemIndices,
                        itemData.__id
                    );

                    visitCompletion.completed += itemCompletion.completed || 0;
                    visitCompletion.overdue += itemCompletion.overdue || 0;
                    visitCompletion.planned += itemCompletion.planned || 0;
                    visitCompletion.pending += itemCompletion.pending || 0;
                    visitCompletion.total += itemCompletion.total || 0;
                });

                return visitCompletion;
            }

            function calculateSectionsContainerVisitCompletion(
                container,
                listIndices
            ) {
                // Same logic as Completion.js getSectionsContainerCompletion
                var visitCompletion = {
                    completed: 0,
                    overdue: 0,
                    planned: 0,
                    pending: 0,
                    total: 0,
                    visitBased: false,
                };

                var children = container.getChildren ? container.getChildren() : [];
                children.forEach(function(child) {
                    var childCompletion = calculateVisitCompletion(child, listIndices);

                    visitCompletion.completed += childCompletion.completed || 0;
                    visitCompletion.overdue += childCompletion.overdue || 0;
                    visitCompletion.planned += childCompletion.planned || 0;
                    visitCompletion.pending += childCompletion.pending || 0;
                    visitCompletion.total += childCompletion.total || 0;
                    visitCompletion.visitBased =
            visitCompletion.visitBased || childCompletion.visitBased;
                });

                return visitCompletion;
            }

            function calculateListItemVisitCompletion(element, listIndices, itemId) {
                if (!CrdConfigurationService.hasScheduledVisits()) {
                    // Fallback to standard completion for list items
                    var completion = FieldsCompletionService.getListItemCompletion(
                        element,
                        listIndices,
                        itemId
                    );

                    return {
                        completed: completion.completed || 0,
                        overdue: 0,
                        planned: 0,
                        pending: completion.pending || 0,
                        total: completion.required || 0,
                        visitBased: false,
                    };
                }

                // Same logic as Completion.js getListItemCompletion
                return calculateSectionsContainerVisitCompletion(element, listIndices);
            }

            function initVisitCompletion(itemMetadata, listIndices) {
                itemMetadata.visitCompletion = calculateVisitCompletion(
                    itemMetadata.element,
                    listIndices
                );
            }

            function reloadVisitCompletion(itemMetadata, listIndices) {
                var previousValue = itemMetadata.visitCompletion;
                var newValue =
          itemMetadata.type === 'listItem'
              ? calculateListItemVisitCompletion(
                  itemMetadata.element,
                  listIndices,
                  itemMetadata.id
              )
              : calculateVisitCompletion(itemMetadata.element, listIndices);

                itemMetadata.visitCompletion = newValue;

                return hasChanged(previousValue, newValue);
            }

            function updateFromChildren(itemMetadata) {
                var currentValue = itemMetadata.visitCompletion;
                var newValue = itemMetadata.children.reduce(
                    function(acc, child) {
                        var childCompletion = child.visitCompletion || {};

                        return {
                            completed: acc.completed + (childCompletion.completed || 0),
                            overdue: acc.overdue + (childCompletion.overdue || 0),
                            planned: acc.planned + (childCompletion.planned || 0),
                            pending: acc.pending + (childCompletion.pending || 0),
                            total: acc.total + (childCompletion.total || 0),
                            visitBased: acc.visitBased || childCompletion.visitBased,
                        };
                    },
                    {
                        completed: 0,
                        overdue: 0,
                        planned: 0,
                        pending: 0,
                        total: 0,
                        visitBased: false,
                    }
                );

                itemMetadata.visitCompletion = newValue;

                return hasChanged(currentValue, newValue);
            }

            return {
                initFormFlags: function(
                    itemMetadata,
                    elementId,
                    entityData,
                    stateParams
                ) {
                    var listIndices = CrfService.getListIndices(stateParams);
                    initVisitCompletion(itemMetadata, listIndices);
                },

                initSectionFlags: function(
                    itemMetadata,
                    elementId,
                    entityData,
                    stateParams
                ) {
                    if (angular.isUndefined(itemMetadata)) {
                        itemMetadata = {};
                    }

                    var listIndices = CrfService.getListIndices(stateParams);
                    initVisitCompletion(itemMetadata, listIndices);
                },

                initListFlags: function(
                    itemMetadata,
                    elementId,
                    entityData,
                    stateParams
                ) {
                    if (angular.isUndefined(itemMetadata)) {
                        itemMetadata = {};
                    }

                    var listIndices = CrfService.getListIndices(stateParams);

                    // Lists use their own calculation method
                    itemMetadata.visitCompletion = calculateListVisitCompletion(
                        itemMetadata.element,
                        listIndices
                    );
                },

                initListItemFlags: function(itemMetadata, elementId, stateParams) {
                    if (angular.isUndefined(itemMetadata)) {
                        itemMetadata = {};
                    }

                    var listIndices = CrfService.getListIndices(stateParams);
                    if (angular.isUndefined(listIndices[elementId])) {
                        var itemId = itemMetadata.id;
                        listIndices[elementId] = RecordDataService.getListItemIndex(
                            elementId,
                            itemId,
                            listIndices
                        );
                    }

                    itemMetadata.visitCompletion = calculateListItemVisitCompletion(
                        itemMetadata.element,
                        listIndices,
                        itemMetadata.id
                    );
                },

                onElementFlagChangedCompletion: function(argumentsList) {
                    var itemMetadata = argumentsList[0];
                    var listIndices = argumentsList[3].listIndices;

                    return reloadVisitCompletion(itemMetadata, listIndices);
                },

                onListItemCreated: function(argumentsList) {
                    var itemMetadata = argumentsList[0];
                    var stateParams = argumentsList[2];
                    var listIndices = CrfService.getListIndices(stateParams);

                    return reloadVisitCompletion(itemMetadata, listIndices);
                },

                onListItemDeleted: function(argumentsList) {
                    var itemMetadata = argumentsList[0];
                    var stateParams = argumentsList[2];
                    var listIndices = CrfService.getListIndices(stateParams);

                    return reloadVisitCompletion(itemMetadata, listIndices);
                },

                propagate: function(itemMetadata) {
                    return updateFromChildren(itemMetadata);
                },

                reloadFlags: function(
                    itemMetadata,
                    elementId,
                    elementType,
                    sectionState,
                    stateParams
                ) {
                    var listIndices = CrfService.getListIndices(stateParams);

                    return reloadVisitCompletion(itemMetadata, listIndices);
                },

                reloadItemFlags: function(
                    itemMetadata,
                    itemState,
                    stateParams,
                    elementId
                ) {
                    var listIndices = CrfService.getListIndices(stateParams);

                    // Ensure the list index is set for the item
                    if (angular.isUndefined(listIndices[elementId])) {
                        var itemId = itemMetadata.id;
                        listIndices[elementId] = RecordDataService.getListItemIndex(
                            elementId,
                            itemId,
                            listIndices
                        );
                    }

                    return reloadVisitCompletion(itemMetadata, listIndices);
                },
            };
        },
    ]);
